import { USE_NEW_PLAN_LOGIC } from '../../utils/constant'

const MODULE_OVERVIEWS = {
  '/': {
    moduleName: 'Vision del negocio',
    message:
      'Aqui ves el estado general del negocio, con indicadores, presupuesto y proyecciones.',
    detail:
      'Cada tab te muestra una capa distinta para analizar el estado y la proyeccion de la empresa.'
  },
  '/administracion': {
    moduleName: 'Administracion',
    message:
      'Este modulo concentra la operacion diaria de clientes, proveedores, bancos y flujos asociados.',
    detail:
      'Aqui la ayuda cambia segun la tab que estes revisando, para explicarte esa vista puntual.'
  },
  '/inventario': {
    moduleName: 'Inventario',
    message: 'Desde aqui controlas bodegas, items, movimientos y cargas masivas.',
    detail:
      'Inventario se organiza por secciones funcionales, asi que veras ayuda distinta segun cada vista.'
  },
  '/reportes': {
    moduleName: 'Reportes',
    message:
      'En este modulo accedes a los distintos informes contables, financieros y de control.',
    detail:
      'Aqui la orientacion es mas general, porque funciona como un catalogo de reportes.'
  },
  '/micontador': {
    moduleName: 'Mi Contador',
    message: 'Agrupa todas las herramientas necesarias para llevar tu contabilidad al día y sin fricciones.',
    detail: 'Gestiona comprobantes, revisa tu balance y mantén la trazabilidad financiera que tu empresa necesita mes a mes.'
  },
  '/chat': {
    moduleName: 'TryLuca AI',
    message:
      'Este modulo te permite conversar con el asistente y revisar conversaciones guardadas.',
    detail: 'La ayuda cambia segun si estas en chat, historial o destacados.'
  },
  '/ajustes': {
    moduleName: 'Ajustes',
    message:
      'Aqui configuras la empresa, usuarios, plan de cuentas, integraciones y otras opciones base.',
    detail: 'Cada tab corresponde a una capa distinta de configuracion.'
  },
  '/facturacion': {
    moduleName: 'Facturacion',
    message:
      'Desde aqui puedes revisar emitidos, emitir documentos y manejar programaciones.',
    detail:
      'La ayuda contextual cambia segun si estas revisando emitidos, emision o programaciones.'
  }
}

const ROUTE_KEY_ALIASES = {
  '/BusinessInsights': '/'
}

const createStep = ({
  id,
  moduleName,
  eyebrow,
  title,
  description,
  detail,
  pathname = '',
  search = ''
}) => ({
  id,
  moduleName,
  eyebrow,
  title,
  description,
  detail,
  target: pathname ? { pathname, search } : null
})

const createOverviewStep = (pathname, search = '') => {
  const overview = MODULE_OVERVIEWS[pathname]

  return createStep({
    id: `overview-${pathname}`,
    moduleName: overview.moduleName,
    eyebrow: overview.moduleName,
    title: overview.moduleName,
    description: overview.message,
    detail: overview.detail,
    pathname,
    search
  })
}

const BUSINESS_INSIGHTS_TAB_STEPS = [
  createStep({
    id: 'business-insights-tab-vision',
    moduleName: 'Vision del negocio',
    eyebrow: 'Tab',
    title: 'Vision del negocio',
    description:
      'Esta tab resume indicadores clave para entender rapidamente como va la empresa.',
    detail: 'Es la vista mas ejecutiva del modulo.',
    pathname: '/',
    search: '?tab=vision-negocio'
  }),
  createStep({
    id: 'business-insights-tab-presupuesto',
    moduleName: 'Vision del negocio',
    eyebrow: 'Tab',
    title: 'Presupuesto',
    description:
      'Aqui proyectas y comparas presupuestos para anticipar desbalances y escenarios.',
    detail: 'Sirve para planificar en vez de reaccionar tarde.',
    pathname: '/',
    search: '?tab=presupuesto'
  }),
  createStep({
    id: 'business-insights-tab-reportes',
    moduleName: 'Vision del negocio',
    eyebrow: 'Tab',
    title: 'Reportes',
    description:
      'Esta tab concentra reportes orientados al analisis del negocio dentro del modulo.',
    detail: 'Es util para bajar del indicador a una vista mas detallada.',
    pathname: '/',
    search: '?tab=reportes'
  }),
  createStep({
    id: 'business-insights-tab-f29',
    moduleName: 'Vision del negocio',
    eyebrow: 'Tab',
    title: 'Proyeccion F29',
    description:
      'Aqui visualizas una proyeccion tributaria para anticipar el comportamiento del F29.',
    detail: 'Te ayuda a revisar el impacto antes del cierre.',
    pathname: '/',
    search: '?tab=proyeccion-f29'
  })
]

const ADMIN_TAB_STEPS = [
  {
    key: 'clientes',
    title: 'Clientes',
    description:
      'Esta tab centraliza ingresos, movimientos y control operativo asociado a clientes.'
  },
  {
    key: 'proveedores',
    title: 'Proveedores',
    description: 'Aqui revisas egresos y seguimiento operativo relacionado con proveedores.'
  },
  {
    key: 'bancos',
    title: 'Bancos',
    description:
      'Esta vista sirve para conectar cuentas, revisar movimientos y conciliacion bancaria.'
  },
  {
    key: 'pagos',
    title: 'Pagos Digitales',
    description:
      'Aqui gestionas movimientos y resumenes provenientes de proveedores de pago digital.'
  },
  {
    key: 'vinculaciones',
    title: 'Vinculaciones',
    description:
      'Esta tab te ayuda a relacionar y depurar movimientos para darles trazabilidad.'
  },
  {
    key: 'remuneraciones',
    title: 'Remuneraciones',
    description: 'Centraliza la informacion de remuneraciones y cotizaciones previsionales de tu equipo. Revisa y concilia todo desde esta sección',
    detail: 'Carga liquidaciones masivamente, revisa los montos consolidados por período y mantén tus conciliaciones al día de forma automatizada.'
  },
  {
    key: 'gestion',
    title: 'Gestion Comercial',
    description: 'Mantén una vista consolidada de toda tu operación comercial.',
    detail: 'Haz seguimiento a tus clientes y proveedores desde un solo lugar para potenciar el crecimiento de tu negocio.'
  }
].map(tab =>
  createStep({
    id: `administracion-tab-${tab.key}`,
    moduleName: 'Administracion',
    eyebrow: 'Tab',
    title: tab.title,
    description: tab.description,
    detail: tab.detail || 'Cada pestana separa un frente operativo distinto dentro de Administracion.',
    pathname: '/administracion',
    search: `?tab=${tab.key}`
  })
)

const INVENTORY_TAB_STEPS = [
  {
    key: 'warehouses',
    search: '?view=warehouses',
    title: 'Bodegas',
    description:
      'Aqui defines las bodegas o ubicaciones fisicas donde operara el inventario.'
  },
  {
    key: 'items',
    search: '?view=items',
    title: 'Items',
    description: 'En esta seccion administras el catalogo base de productos e insumos.'
  },
  {
    key: 'operations',
    search: '?view=operations',
    title: 'Operaciones',
    description: 'Esta tab sirve para registrar movimientos manuales y transferencias.'
  },
  {
    key: 'recipes',
    search: '?view=recipes',
    title: 'Recetas',
    description: 'Aqui configuras recetas o composiciones para productos armados.'
  },
  {
    key: 'stock',
    search: '?view=stock',
    title: 'Stock',
    description: 'Esta vista te muestra el stock actual disponible.'
  },
  {
    key: 'movements',
    search: '?view=movements',
    title: 'Movimientos',
    description: 'Aqui revisas el historial completo de entradas, salidas y transferencias.'
  },
  {
    key: 'uploads',
    search: '?view=uploads',
    title: 'Carga Excel',
    description: 'Esta seccion sirve para cargas masivas de items y stock inicial.'
  }
].map(tab =>
  createStep({
    id: `inventario-tab-${tab.key}`,
    moduleName: 'Inventario',
    eyebrow: 'Seccion',
    title: tab.title,
    description: tab.description,
    detail: 'Inventario se organiza por secciones funcionales en vez de tabs clasicas.',
    pathname: '/inventario',
    search: tab.search
  })
)

const CHAT_TAB_STEPS = [
  {
    key: 'chat',
    title: 'Chat Principal',
    description:
      'Esta es la vista principal para conversar con Luca y continuar una conversacion activa.'
  },
  {
    key: 'history',
    title: 'Historial de Chats',
    description:
      'Aqui puedes revisar conversaciones anteriores y retomarlas cuando lo necesites.'
  },
  {
    key: 'favorites',
    title: 'Destacados',
    description: 'Esta tab agrupa conversaciones marcadas como importantes.'
  }
].map(tab =>
  createStep({
    id: `chat-tab-${tab.key}`,
    moduleName: 'TryLuca AI',
    eyebrow: 'Tab',
    title: tab.title,
    description: tab.description,
    detail: 'Asi separas conversaciones activas, historicas y favoritas.',
    pathname: '/chat',
    search: `?tab=${tab.key}`
  })
)

const SETTINGS_TAB_STEPS = [
  /*{
    key: 'empresa',
    title: 'Ajustes de la Empresa',
    description: 'Configura los cimientos de tu cuenta y la identidad de tu negocio.',
    detail: 'Define los datos legales y tributarios de tu empresa, personaliza tu entorno y asegura que toda la información base esté correcta y actualizada.'
  },*/
  {
    key: 'plan-cuentas',
    title: 'Plan de cuentas',
    description: 'Adapta la estructura contable a la realidad de tu negocio.',
    detail: 'Revisa, edita o agrega nuevas cuentas contables. Esta estructura será la base para todos tus reportes y balances.'
  },
  {
    key: 'usuarios',
    title: 'Usuarios',
    description: 'Administra tu equipo de trabajo y controla los accesos a tu información.',
    detail: 'Invita a nuevos colaboradores, asigna roles específicos (como administrador o contador) y gestiona los permisos de toda tu organización.'
  },
  {
    key: 'centro-costos',
    title: 'Centro de costos',
    description: 'Organiza y segmenta tus finanzas para tener un control mucho más detallado.',
    detail: 'Crea distintos centros de costo para asignar tus ingresos y gastos a diferentes áreas, proyectos o sucursales de tu empresa.'
  },
  {
    key: 'integraciones',
    title: 'Integraciones',
    description: 'Conecta LUCA con tus plataformas favoritas para automatizar tu operación.',
    detail: 'Sincroniza tu información al instante integrando cuentas de Mercado Pago, Buk y Getnet directamente a tu ecosistema.'
  },
  ...(USE_NEW_PLAN_LOGIC
    ? [
        {
          key: 'pagos',
          title: 'Planes',
          description: 'Esta tab concentra la gestion de plan, tarjetas y cobros asociados.'
        }
      ]
    : [])
].map(tab =>
  createStep({
    id: `ajustes-tab-${tab.key}`,
    moduleName: 'Ajustes',
    eyebrow: 'Tab',
    title: tab.title,
    description: tab.description,
    detail: tab.detail || '',
    pathname: '/ajustes',
    search: `?tab=${tab.key}`
  })
)

const FACTURACION_TAB_STEPS = [
  {
    key: 'emitidas',
    title: 'Facturas emitidas',
    description: 'Aqui revisas los documentos ya emitidos y su trazabilidad.'
  },
  {
    key: 'individual',
    title: 'Emitir factura individual',
    description: 'Esta tab esta pensada para emitir un documento de forma manual.'
  },
  {
    key: 'masivas',
    title: 'Emitir facturas masivas',
    description: 'Aqui puedes cargar y emitir multiples documentos en un mismo flujo.'
  },
  {
    key: 'programadas',
    title: 'Facturas programadas',
    description: 'Esta vista administra documentos recurrentes o calendarizados.'
  }
].map(tab =>
  createStep({
    id: `facturacion-tab-${tab.key}`,
    moduleName: 'Facturacion',
    eyebrow: 'Tab',
    title: tab.title,
    description: tab.description,
    detail: 'Facturacion separa revision, emision individual, masiva y programada.',
    pathname: '/facturacion',
    search: `?tab=${tab.key}`
  })
)

export const ASSISTANT_PET_ROUTE_MESSAGES = {
  '/': MODULE_OVERVIEWS['/'].message,
  '/BusinessInsights': MODULE_OVERVIEWS['/'].message,
  '/administracion': MODULE_OVERVIEWS['/administracion'].message,
  '/inventario': MODULE_OVERVIEWS['/inventario'].message,
  '/reportes': MODULE_OVERVIEWS['/reportes'].message,
  '/micontador': MODULE_OVERVIEWS['/micontador'].message,
  '/chat': MODULE_OVERVIEWS['/chat'].message,
  '/ajustes': MODULE_OVERVIEWS['/ajustes'].message,
  '/configuracion': MODULE_OVERVIEWS['/ajustes'].message,
  '/facturacion': MODULE_OVERVIEWS['/facturacion'].message
}

export const ASSISTANT_PET_DEFAULT_MESSAGE =
  'Estoy aqui para ayudarte a recorrer esta seccion.'

export const getAssistantPetRouteKey = pathname => {
  if (!pathname) return null

  return ROUTE_KEY_ALIASES[pathname] || (MODULE_OVERVIEWS[pathname] ? pathname : null)
}

export const getAssistantPetMessage = pathname => {
  const routeKey = getAssistantPetRouteKey(pathname)
  return routeKey ? MODULE_OVERVIEWS[routeKey].message : ASSISTANT_PET_DEFAULT_MESSAGE
}

const buildAssistantPetSteps = ({ includeBilling = false } = {}) => {
  const steps = [
    createStep({
      id: 'tour-intro',
      eyebrow: 'TryLuca',
      title: 'Bienvenido',
      description: 'Voy a guiarte por los modulos principales del sistema.',
      detail:
        'Este conjunto de mensajes tambien se reutiliza para entregar ayuda contextual segun donde estes.'
    }),
    createOverviewStep('/'),
    ...BUSINESS_INSIGHTS_TAB_STEPS,
    createOverviewStep('/administracion'),
    ...ADMIN_TAB_STEPS,
    createOverviewStep('/inventario'),
    ...INVENTORY_TAB_STEPS,
    createOverviewStep('/reportes'),
    createOverviewStep('/micontador'),
    createStep({
      id: 'micontador-tab-comprobantes',
      moduleName: 'Mi Contador',
      title: 'Comprobantes',
      description: 'Aqui trabajas el flujo principal de comprobantes contables del modulo.',
      detail: 'Es la tab central de la version actual de Mi Contador.',
      pathname: '/micontador'
    }),
    createOverviewStep('/chat'),
    ...CHAT_TAB_STEPS,
    createOverviewStep('/ajustes'),
    ...SETTINGS_TAB_STEPS
  ]

  if (includeBilling) {
    steps.push(createOverviewStep('/facturacion'))
    steps.push(...FACTURACION_TAB_STEPS)
  }

  return steps
}

const matchesSearchParams = (expectedSearch = '', currentSearch = '') => {
  if (!expectedSearch) return true

  const expectedParams = new URLSearchParams(expectedSearch.replace(/^\?/, ''))
  const currentParams = new URLSearchParams(currentSearch.replace(/^\?/, ''))

  for (const [key, value] of expectedParams.entries()) {
    if (currentParams.get(key) !== value) {
      return false
    }
  }

  return true
}

export const getAssistantPetTourSteps = ({ includeBilling = false } = {}) =>
  buildAssistantPetSteps({ includeBilling })

export const getAssistantPetContext = (
  pathname,
  search = '',
  { includeBilling = false } = {}
) => {
  const steps = buildAssistantPetSteps({ includeBilling }).filter(
    step => step.id !== 'tour-intro'
  )

  const exactMatch = steps.find(
    step =>
      step.target?.pathname === pathname &&
      step.target?.search &&
      matchesSearchParams(step.target.search, search)
  )

  if (exactMatch) {
    return exactMatch
  }

  const routeKey = getAssistantPetRouteKey(pathname)

  if (routeKey) {
    const overviewMatch = steps.find(
      step => step.target?.pathname === routeKey && !step.target?.search
    )

    if (overviewMatch) {
      return overviewMatch
    }
  }

  return {
    id: `fallback-${pathname || 'root'}`,
    moduleName: 'LUCA',
    eyebrow: 'LUCA',
    title: 'LUCA',
    description: ASSISTANT_PET_DEFAULT_MESSAGE,
    detail: 'Muevete por el sistema y te mostrare ayuda contextual segun la vista actual.',
    target: null
  }
}

export const getOnboardingTourSteps = () => [
  // ─── BIENVENIDA ──────────────────────────────────────────────────────────────
  {
    id: 'tour-welcome',
    moduleName: 'LUCA',
    eyebrow: 'LUCA',
    title: '¡Hola, soy LUCA!',
    description: 'Seré tu copiloto financiero inteligente. Saquemos de tu mesa el trabajo administrativo aburrido para darte superpoderes reales.\n\n¿Hacemos un tour rápido de 45 segundos?',
    detail: 'Si te incomodo, puedes moverme libremente a cualquier rincón de la pantalla.',
    target: { pathname: '/' },
    petState: 'welcome'
  },

  // ─── VISIÓN DEL NEGOCIO ───────────────────────────────────────────────────────
  {
    id: 'tour-vision-intro',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1',
    title: 'Visión del Negocio',
    description: 'Tu sala de control financiero en tiempo real. Olvídate de armar planillas a ciegas: aquí tienes las métricas clave de tu empresa organizadas de lo general a lo específico para decidir rápido.',
    detail: 'Navega entre las pestañas superiores para explorar cada vista.',
    target: { pathname: '/', search: '?tab=vision-negocio' },
    petState: 'idea'
  },
  {
    id: 'tour-vision-ingresos',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · Gráficos',
    title: 'Ingresos vs Egresos',
    description: 'Este gráfico te muestra mes a mes cuánto vendiste, cuánto gastaste y cuanto ganó tu negocio durante los últimos 12 meses. De un vistazo puedes identificar los meses donde gastaste más de lo que facturaste.',
    detail: 'Recuerda que puedes moverme por la pantalla, con solo arrastrarme.',
    target: { pathname: '/', search: '?tab=vision-negocio' },
    targetElementId: 'chart-ingresos-egresos',
    petSide: 'right',
    petState: 'idea'
  },
  {
    id: 'tour-vision-resultado',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · Gráficos',
    title: 'Resultado Operativo del Período',
    description: 'Aquí ves si el negocio está ganando o perdiendo plata en el período seleccionado. Es la diferencia neta entre tus ventas, costos y gastos operacionales.',
    detail: 'Si el resultado es rojo, estás gastando más de lo que facturas.',
    detailIcon: true,
    target: { pathname: '/', search: '?tab=vision-negocio' },
    targetElementId: 'chart-resultado-operativo', 
    petState: 'happy'
  },
  {
    id: 'tour-vision-presupuesto-caja',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · Gráficos',
    title: 'Proyección Presupuesto de Caja',
    description: 'Este gráfico proyecta tu flujo de caja futuro cruzando las cuentas por cobrar y por pagar con tu saldo actual. Te permite anticipar si vas a necesitar financiamiento o si tendrás excedentes.',
    detail: 'Úsalo para planificar pagos y cobros antes de que se venzan.',
    target: { pathname: '/', search: '?tab=vision-negocio' },
    targetElementId: 'chart-presupuesto-caja',
    petSide: 'right',
    petState: 'idea'
  },
  {
    id: 'tour-vision-deuda',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · Gráficos',
    title: 'Envejecimiento de la Deuda',
    description: 'Este gráfico te muestra cuánto tiempo llevan sin cobrarse tus facturas de ventas. Mientras más antiguas, más riesgo de que no se cobren.',
    detail: 'Prioriza el cobro de las deudas que llevan más tiempo.',
    detailIcon: true,
    target: { pathname: '/', search: '?tab=vision-negocio' },
    targetElementId: 'chart-envejecimiento-deuda',
    petSide: 'right', 
    petState: 'confuse'
  },
  {
    id: 'tour-vision-presupuesto',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · Presupuesto',
    title: 'Presupuesto',
    description: 'Planifica en vez de reaccionar cuando ya es tarde. Aquí puedes simular escenarios, crear presupuestos y compararlos contra la realidad.',
    detail: 'Administrar tu negocio con datos reales en vez de intuición marca la diferencia.',
    target: { pathname: '/', search: '?tab=presupuesto' },
    petState: 'happy'
  },
  // Dile adiós a las sorpresas de fin de mes con el SII. LUCA procesa tus datos automáticamente y te proyecta el IVA e impuestos que deberás declarar, permitiéndote reservar la caja exacta
  {
    id: 'tour-vision-f29',
    moduleName: 'Visión del Negocio',
    eyebrow: 'Módulo 1 · F29',
    title: 'Proyección F29',
    description: 'El F29 es el formulario mensual que debes presentar al SII con el IVA y otros impuestos. Esta pestaña te muestra una proyección de cuánto deberías pagar antes del cierre, para que no te tome por sorpresa. Ademas te muestra los pagos historicos de F29 y es el lugar donde puedes conciliarlos.',
    detail: 'Revísala antes del cierre mensual y mantén un flujo de caja real y sin sobresaltos.',
    detailIcon: true,
    target: { pathname: '/', search: '?tab=proyeccion-f29' },
    petState: 'idea'
  },

  // ─── GESTIÓN OPERATIVA ────────────────────────────────────────────────────────
  {
    id: 'tour-admin-intro',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2',
    title: 'Clientes y Proveedores',
    description: 'El núcleo de tu administración diaria. Aquí controlas el flujo comercial de la empresa: en la sección de Clientes sigues tus ingresos y cuentas por cobrar, mientras que en Proveedores vigilas tus egresos y cuentas por pagar.',
    detail: 'Además navegando por las pensatañas puedes revisar bancos, pagos digitales, etc. ¡Vamos!',
    target: { pathname: '/administracion', search: '?tab=clientes' },
    petState: 'happy'
  },
  {
    id: 'tour-admin-bancos',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2 · Bancos',
    title: 'Bancos',
    description: 'La magia de la automatización. Ve a esta pestaña para vincular tus cuentas bancarias y deja que LUCA importe tus movimientos. El sistema hará conciliaciones automáticas con tus documentos tributarios mediante IA, sin que digites nada a mano.',
    detail: 'La vinculación y conciliación bancaria es uno de tus mayores ahorros de tiempo.',
    // TODO: Reemplazar '#' con la URL de YouTube del paso a paso para vincular un banco
    // links: [
    //   { type: 'video', url: 'https://www.youtube.com/watch?v=MdDf3M-YjZk', label: 'Ver cómo vincular un banco' }
    // ],
    target: { pathname: '/administracion', search: '?tab=bancos' },
    petAlignRight: true,
    petState: 'idea'
  },
  {
    id: 'tour-admin-pagos',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2 · Pagos Digitales',
    title: 'Pagos Digitales',
    description: 'Centraliza tus canales de cobro. Dirígete a esta pestaña para revisar las funciones de integración con Transbank, Mercado Pago, GetNet u otros proveedores. Verás todos los resúmenes y abonos unificados sin tener que saltar de portal en portal.',
    detail: 'Controla todas tus pasarelas de pago desde una única pantalla.',
    // TODO: Reemplazar '#' con la URL de YouTube del paso a paso para pagos digitales
    // links: [
    //   { type: 'video', url: 'https://www.youtube.com/watch?v=MdDf3M-YjZk', label: 'Ver cómo conectar pagos digitales' }
    // ],
    target: { pathname: '/administracion', search: '?tab=pagos' },
    petAlignRight: true,
    petState: 'happy'
  },

  // ─── VINCULACIONES, REMUNERACIONES, GESTIÓN COMERCIAL ─────────────────────────
  {
    id: 'tour-admin-vinculaciones',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2 · Vinculaciones',
    title: 'Vinculaciones',
    description: 'Aquí relacionas movimientos bancarios cuando no tienes documentos tributarios para darles trazabilidad completa. Ademas, encontraras algunas vinculaciones de mucha utilidad para administrar tu empresa',
    detail: 'Una buena vinculación mantiene tu contabilidad limpia y tus conciliaciones al día.',
    target: { pathname: '/administracion', search: '?tab=vinculaciones' },
    petState: 'idea'
  },
  {
    id: 'tour-admin-remuneraciones',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2 · Remuneraciones',
    title: 'Remuneraciones',
    description: 'Centraliza la gestión de sueldos y previred de tu equipo. Carga liquidaciones de forma masiva, revisa los montos consolidados por período y concilia los pagos con tus movimientos bancarios.',
    detail: 'Automatiza la carga para no digitar planilla por planilla cada mes.',
    target: { pathname: '/administracion', search: '?tab=remuneraciones' },
    petState: 'happy'
  },
  {
    id: 'tour-admin-gestion',
    moduleName: 'Gestión Operativa',
    eyebrow: 'Módulo 2 · Gestión Comercial',
    title: 'Gestión Comercial',
    description: 'Tu vista consolidada del negocio comercial. Desde aquí haces seguimiento a tus clientes y proveedores en cada detalle. No dejes de revisar esta sección.',
    detail: 'Ideal para mantener la visibilidad de todo el ciclo comercial en un solo lugar.',
    target: { pathname: '/administracion', search: '?tab=gestion' },
    petState: 'happy'
  },

  // ─── FACTURAS ─────────────────────────────────────────────────────────────────
  {
    id: 'tour-billing-intro',
    moduleName: 'Facturas',
    eyebrow: 'Módulo 3',
    title: 'Emisión de Facturas',
    description: 'Si ocupas el facturador gratuito del SII dale super poderes. Desde esta vista general manejas el ciclo completo: revisa el historial de documentos ya emitidos, genera facturas individuales manualmente o escala tu operación realizando facturación masiva y programada.',
    detail: 'Tus horas de facturación se convierten en minutos y sin la necesaidad de navegar en diferentes portales.',
    target: { pathname: '/facturacion' },
    petState: 'confuse'
  },
  {
    id: 'tour-billing-masivas',
    moduleName: 'Facturas',
    eyebrow: 'Módulo 3 · Masivas',
    title: 'Facturas Masivas',
    description: '¿Fin de mes y decenas de clientes por facturar? Entra a esta sección para cargar un archivo con los datos del período y LUCA emitirá todos los documentos en un solo flujo continuo. Convierte horas de digitación pesada en un par de clics',
    detail: 'Reduce días de estrés administrativo a solo un par de minutos.',
    // TODO: Reemplazar '#' con la URL de YouTube del paso a paso para facturación masiva
    // links: [
    //   { type: 'video', url: 'https://www.youtube.com/watch?v=MdDf3M-YjZk', label: 'Ver cómo emitir facturas masivas' }
    // ],
    target: { pathname: '/facturacion', search: '?tab=masivas' },
    petState: 'excited'
  },
  {
    id: 'tour-billing-programadas',
    moduleName: 'Facturas',
    eyebrow: 'Módulo 3 · Programadas',
    title: 'Facturas Programadas',
    description: 'Aquí podrás programar facturas recurrentes a tus clientes como arriendos o membresias. Con solo cargar un archivo y hacer un par de clics tendrás tus facturas programadas.',
    detail: 'Pon tus ingresos recurrentes en piloto automático.',
    // TODO: Reemplazar '#' con la URL de YouTube del paso a paso para facturas programadas
    // links: [
    //   { type: 'video', url: 'https://www.youtube.com/watch?v=MdDf3M-YjZk', label: 'Ver cómo programar facturas' }
    // ],
    target: { pathname: '/facturacion', search: '?tab=programadas' },
    petState: 'yes'
  },
  // ─── INFORMES CONTABLES ───────────────────────────────────────────────────────
  {
    id: 'tour-reports',
    moduleName: 'Informes Contables',
    eyebrow: 'Módulo 4',
    title: 'Reportes',
    description: 'Accede a los reportes financieros y contables incluidos en tu plan. Diseñamos este espacio para que analices la rentabilidad y la estructura de tu empresa con todos los reportes disponibles.',
    detail: 'Recuerda que los tipos de reportes varían según tu plan.',
    detailIcon: true,
    // TODO: Reemplazar '#' con la URL de la plataforma (Notion u otra) con el diccionario de reportes
    links: [
      { type: 'external', url: 'https://scientific-limit-806.notion.site/Diccionario-de-Reportes-Contables-62d3b809a51e4d64b59a334d8d0a7776', label: 'Diccionario de reportes contables' }
    ],
    target: { pathname: '/reportes' },
    petState: 'idea'
  },

  // ─── AJUSTES / PLANES ─────────────────────────────────────────────────────────
  {
    id: 'tour-settings-planes',
    moduleName: 'Ajustes',
    eyebrow: 'Módulo 5',
    title: 'Ajustes y Configuración',
    description: 'En Ajustes configuras tu empresa, gestionas usuarios, permisos y administras tu plan de suscripción. Cada plan desbloquea distintas funcionalidades: mientras más completo el plan, más herramientas tienes disponibles.',
    detail: 'Aquí también puedes actualizar o cambiar tu plan cuando lo necesites.',
    // TODO: Reemplazar '#' con la URL de la landing page de planes y la URL del PDF comparativo
    links: [
      { type: 'external', url: 'https://tryluca.cl/planes', label: 'Ver planes disponibles' },
      { type: 'download', url: 'https://storage.googleapis.com/tryluca-public-assets/comparativo_planes_final.pdf', label: 'Descargar comparativo de planes (PDF)' }
    ],
    target: { pathname: '/ajustes', search: '?tab=pagos' },
    petState: 'happy'
  },

  // ─── ASISTENTE CONVERSACIONAL ─────────────────────────────────────────────────
  {
    id: 'tour-chat',
    moduleName: 'Tu Asistente',
    eyebrow: 'Módulo 6',
    title: '¡Tu Asistente Conversacional!',
    description: '¡Llegamos a mi mente! Pregúntame lo que quieras en lenguaje natural (ej: "¿Cuánto gasté este mes?") y te responderé al instante. ¡Empecemos!',
    detail: '¡Con esto finalizamos el tour! Ahora puedes interactuar directamente conmigo.',
    target: { pathname: '/chat' },
    petState: 'yes'
  }
]
